<template>
  <GrupoLeyendaCheck
    titulo="Minería"
    checkboxType="switch"
    v-model="minas_expanded"
  >
    <!-- <BotonQuitarTodos @click="quitarTodos" v-width-control="'30%'" /> -->
    <span v-width-control="'40%'"></span>
    <BotonMasInfo @click="masInfo" v-width-control="'45%'" />
    <DaiLeyendaMapa
      :para="[
        'minas_activas_legales',
        'minas_activas_ilegales',
        'minas_activas_sininfo',
      ]"
      titulo="Minas activas"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="[
        'minas_inactivas_legales',
        'minas_inactivas_ilegales',
        'minas_inactivas_sininfo',
      ]"
      titulo="Minas inactivas"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="['minas_temporales_legales','minas_temporales_ilegales']"
      titulo="Minas temporales"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
  </GrupoLeyendaCheck>
</template>


<script>
import GrupoLeyendaCheck from "./utils/GrupoLeyendaCheck.vue";
import BotonMasInfo from "./utils/BotonMasInfo.vue";
// import BotonQuitarTodos from "./utils/BotonQuitarTodos.vue";
import { scrollTo } from "@/components/_utils.js";


export default {
  components: {
    GrupoLeyendaCheck,
    // BotonQuitarTodos,
    BotonMasInfo,
  },
  data() {
    return {
    };
  },
  methods: {
    quitarTodos() {},
    masInfo() {
      this.$store.commit("mapa/setFichaActiva", "mineria");
      scrollTo(document.querySelector("[data-section='fichas']"),-102);
    },
  },
  computed: {
    minas_expanded: {
      get() {
        return this.$store.state.mapa.temasExpandidos.mineria;
      },
      set(expandido) {
        this.$store.commit("mapa/setTemasExpandidos", {
          tema: "mineria",
          expandido: expandido,
        });
      },
    },
  },
};
</script>